"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userManagementDefaultValue = exports.userManagementSchema = void 0;
const zod_1 = require("zod");
exports.userManagementSchema = zod_1.z.object({
    teams: zod_1.z.array(zod_1.z.string()),
    profiles: zod_1.z.array(zod_1.z.string()),
    allow_create: zod_1.z.boolean(),
    allow_delete: zod_1.z.boolean(),
});
const defaultValue = {
    allow_create: true,
    allow_delete: true,
    profiles: [],
    teams: [],
};
exports.userManagementDefaultValue = JSON.stringify(defaultValue, null, '\t');
